import { Component, OnInit } from '@angular/core';
import { ShowService } from '../../services/show.service';
import { Show } from '../../models/show.model';
import { Day } from '../../models/day.enum';
import { Schedule } from 'app/models/schedule.model';

class ScheduleInDay {
   public schedule: Schedule;
   public show: Show;
}

@Component({
  selector: 'app-showgrid',
  templateUrl: './showgrid.component.html',
  styleUrls: ['./showgrid.component.scss']
})
export class ShowgridComponent implements OnInit {
  public currentDay: Day = new Day();
  private shows: Show[];
  public schedulesOfDay: ScheduleInDay[] = [];
  public schedulesOfDaySlides: Array<ScheduleInDay[]> = [];
  constructor(private showService: ShowService) { }

  ngOnInit() {
    const argTime = new Date(new Date().toLocaleString('en-US', {timeZone: 'America/Buenos_Aires'}));
    this.showService.getAllShows().subscribe(shows => {
      this.shows = shows;
      this.updateCurrentDay(argTime.getDay());
    });
  }

  updateCurrentDay(day: number | string) {
    this.currentDay = new Day().deserialize(day);
    this.updateSchedulesOfDay(this.currentDay);
  }

  updateSchedulesOfDay(day: Day) {
    this.schedulesOfDay = [];
    this.shows.forEach(show => {
      // Get all schedules for this show for the given day
      const schedules = show.schedulesForDay(day);
      this.schedulesOfDay = this.schedulesOfDay.concat(schedules.map((schedule) => {
        const schedInDay: ScheduleInDay = {show: show, schedule: schedule};
        return schedInDay;
      }));
    });

    this.schedulesOfDay = this.schedulesOfDay.sort((a, b) => {
      const diff_h = a.schedule.start.hours -
                     b.schedule.start.hours;
      if (diff_h === 0) {
        return a.schedule.start.minutes -
               b.schedule.start.minutes;
      } else {
        return diff_h;
      }
    });

    this.schedulesOfDaySlides = this.getInSlides(this.schedulesOfDay);
  }

  getInSlides(list: any[], chunkSize: number = 4) {
      const ret = [];
      for (let i = 0; i < list.length; i += chunkSize) {
        ret.push(list.slice(i, i + chunkSize));
      }
      return ret;
    }
  }
